import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

import { loadProgressBar } from 'axios-progress-bar'

Vue.use(Vuex);

const URL = 'http://localhost:8085/api/';
const MAIL = 'http://codigo46.me:3000/mail/sekai'

var store = new Vuex.Store({
    state: {
        itemSelected: 'Index',
       servicio: "empresa",
       loading: false,
    },
    mutations: {
        select_menu (state, menu) {
            state.itemSelected = menu
        },
       SET_LOADING: (state, loading) => {
          state.loading = loading;
       },

    },
    actions: {
        login(context, data) {
            loadProgressBar();
            axios({
                method: 'post',
                url: URL + 'login',
                data: data
            }).then(data => {

            }).catch(error => {

            });
        },
       enviarCorreo: (context, data) => {
          context.commit('SET_LOADING', true);
          axios({
             method: 'post',
             url: MAIL,
             data: data
          }).then(r => {
             setTimeout(() => {
                context.commit('SET_LOADING', false);
             }, 1000)
          });
       },
    }
});

export default store
